export const copyingUserDraftProject = 'copyingUserDraftProject';
